import { render, staticRenderFns } from "./BroadcastLicense.vue?vue&type=template&id=64d5a3d4&scoped=true"
import script from "./BroadcastLicense.vue?vue&type=script&lang=js"
export * from "./BroadcastLicense.vue?vue&type=script&lang=js"
import style0 from "./BroadcastLicense.vue?vue&type=style&index=0&id=64d5a3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5a3d4",
  null
  
)

export default component.exports